import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';

import { LeadNote } from '../../cmg-1003/models/notes.model';
import { LeadNotesDataStore } from './lead-notes.store';

@Injectable({ providedIn: 'root' })
export class LeadNotesQuery extends Query<LeadNote> {
  protected store: LeadNotesDataStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(LeadNotesDataStore);

    super(store);
    this.store = store;

    this.dirtyChecker.setHead();
  }
}
